
// src/components/media/MediaTile.jsx
import React from "react";

/**
 * Uniform image/video tile.
 * - Shows first video frame (no black box) via onLoadedMetadata seek.
 * - Adds controls + playsInline so mobile browsers render + play correctly.
 * - Infers a reasonable MIME type from the URL.
 */
const MediaTile = ({ src, isVideo = false, className = "" }) => {
  const wrap = {
    position: "relative",
    width: "100%",
    aspectRatio: "1 / 1",
    borderRadius: 12,
    overflow: "hidden",
    background: "#000",
  };
  const media = { width: "100%", height: "100%", objectFit: "cover", display: "block" };

  if (!isVideo) {
    return (
      <div style={wrap} className={className}>
        <img
          src={src}
          alt=""
          style={media}
          onError={(e) => (e.currentTarget.src = "/event.png")}
        />
      </div>
    );
  }

  const lower = (src || "").toLowerCase();
  const type =
    lower.endsWith(".webm") ? "video/webm" :
    lower.endsWith(".mov")  ? "video/quicktime" :
    lower.endsWith(".ogv")  ? "video/ogg" :
                               "video/mp4";

  return (
    <div style={wrap} className={className}>
      <video
        style={media}
        controls
        playsInline
        preload="metadata"
        muted        // helps some mobile UAs render the first frame
        onLoadedMetadata={(e) => {
          // force-draw the first frame instead of a black box
          try { e.currentTarget.currentTime = 0.01; } catch {}
        }}
      >
        <source src={src} type={type} />
      </video>

      {/* small badge — won't block clicks */}
      <div
        style={{
          position: "absolute",
          bottom: 8,
          right: 8,
          background: "rgba(0,0,0,.55)",
          color: "#fff",
          fontSize: 12,
          lineHeight: "16px",
          padding: "2px 6px",
          borderRadius: 6,
          pointerEvents: "none",
        }}
      >
        ▶
      </div>
    </div>
  );
};

export default MediaTile;
